import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import GoogleLogin from 'vue3-google-login'

// Vuetify & Co
import '@mdi/font/css/materialdesignicons.css'
import { createApp } from 'vue'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { appTheme, appDefaults } from './utils/themes'
import ToastPlugin from './plugins/toast.js'
import { appStore } from '@/stores/AppStore'
import i18n from './locales/i18n.js'

// Import Bootstrap CSS
// import 'bootstrap/dist/css/bootstrap.min.css';

// Import Bootstrap JS (optional, for components like modals, tooltips, etc.)
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Import Bootstrap Icons
// import 'bootstrap-icons/font/bootstrap-icons.css';

console.log("Google Client ID:", process.env.APP_GOOGLE_CLIENT_ID);

const app = createApp(App);
const pinia = createPinia();
const vuetify = createVuetify(        
    {
        components,
        directives,

        // Uncomment the following 2 lines to allow custom themes
        defaults: appDefaults,
        theme: appTheme,
        
        // // Some very basic theme customization
        // theme: {
        //     defaultTheme: 'light',
        //     themes: {
        //         light: {
        //             dark: false,
        //             colors: {
        //                 primary: '#3f51b5',
        //                 secondary: '#b0bec5',
        //                 accent: '#8c9eff',
        //                 error: '#b71c1c',                    
        //             },
        //         },                
        //     },
        // },
        icons: {
            defaultSet: 'mdi', // This is already the default value - only for display purposes
        },      
    }    
);
app.use(i18n);
app.use(vuetify);
app.use(router);
app.use(GoogleLogin, {
    // clientId: process.env.APP_GOOGLE_CLIENT_ID
    clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID
});


//Start Pinia section
app.use(pinia);
// Initialize store and auth once
const store = appStore()
store.initAuth() // Initialize auth here, once!

// Make store globally available
app.config.globalProperties.store = store
//End Pinia section

app.use(ToastPlugin);
app.mount('#app');
